import styled from "styled-components"

import { ReactComponent as IconInfo } from "assets/svg/icon-info-message.svg"

const Banner = styled.div`
  background: var(--surface-1);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border-radius: 20px;
  margin-bottom: 16px;
`

const BannerText = styled.span`
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.5;
  flex: 1;
`

const IconWrapper = styled.span`
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
  }
`

type InfoBannerProps = {
  text: string
}

const InfoBanner = ({ text }: InfoBannerProps) => (
  <Banner>
    <IconWrapper>
      <IconInfo />
    </IconWrapper>
    <BannerText>{text}</BannerText>
  </Banner>
)

export default InfoBanner
